'use strict';
var storeLocator = require('base/storeLocator/storeLocator');
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}


    function maps () {
        var map;
        var infowindow = new google.maps.InfoWindow();

        // Init U.S. Map in the center of the viewport
        var latlng = new google.maps.LatLng(37.09024, -95.712891);
        var mapOptions = {
            scrollwheel: false,
            zoom: 4,
            center: latlng
        };

        map = new google.maps.Map($('.map-canvas')[0], mapOptions);
        var mapdiv = $('.map-canvas').attr('data-locations');

        mapdiv = JSON.parse(mapdiv);

        var bounds = new google.maps.LatLngBounds();

        // Customized google map marker icon with svg format
        var markerImg = $('#js-map-url').attr('data-mapsrc');

        Object.keys(mapdiv).forEach(function (key) {
            var item = mapdiv[key];
            var lable = parseInt(key, 10) + 1;
            var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            var marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name,
                icon: markerImg
            });

            marker.addListener('click', function () {
                infowindow.setOptions({
                    content: item.infoWindowHtml
                });
                infowindow.open(map, marker);
            });

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);
        });
        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        if (mapdiv && mapdiv.length !== 0) {
            map.fitBounds(bounds);
        }
    }

    function mapss (_noresult) {
        var map;
        var infowindow = new google.maps.InfoWindow();
        var zoom = 4;

        var mapdiv = $('.map-canvas').attr('data-locations');

        // Init U.S. Map in the center of the viewport
        var latlng = new google.maps.LatLng(_noresult.lat, _noresult.long);
        if (mapdiv.length < 3) {
            zoom = 9;
        }
        // calculate zoom value if distance exists in data
        if (_noresult.distance) {
            var width = $('.map-canvas').outerWidth();
            zoom = Math.log2(width / _noresult.distance);
        }
        var mapOptions = {
            scrollwheel: false,
            zoom,
            center: latlng
        };

        map = new google.maps.Map($('.map-canvas')[0], mapOptions);

        mapdiv = JSON.parse(mapdiv);

        var bounds = new google.maps.LatLngBounds();

        // Customized google map marker icon with svg format
        var markerImg = $('#js-map-url').attr('data-mapsrc');

        Object.keys(mapdiv).forEach(function (key) {
            var item = mapdiv[key];
            var lable = parseInt(key, 10) + 1;
            var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            var marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name,
                icon: markerImg
            });

            marker.addListener('click', function () {
                infowindow.setOptions({
                    content: item.infoWindowHtml
                });
                infowindow.open(map, marker);
            });

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);
        });
        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        if (mapdiv && mapdiv.length !== 0) {
            map.fitBounds(bounds);
        }
    }

    /**
     * Search for stores with new zip code
     * @param {HTMLElement} element - the target html element
     * @returns {boolean} false to prevent default event
     */
    function searchLocation(element) {
        var dialog = element.closest('.in-store-inventory-dialog');
        var spinner = dialog.length ? dialog.spinner() : $.spinner();
        spinner.start();
        var $form = element.closest('.store-locator');
        var radius = $('.results').data('radius');
        var url = $form.attr('action');
        var urlParams = { radius: radius };

        var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: $form.attr('method'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                spinner.stop();
                updateStoresResults(data);
                $('.select-store').prop('disabled', true);
            }
        });
        return false;
    }

    function detectLocation () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            }, () => {
                $('#location_denied_alert').fadeIn();
                setTimeout(() => {
                    $('#location_denied_alert').fadeOut();
                }, 3000);
                $.spinner().stop();
            }, {
                enableHighAccuracy: true,
                timeout: 3000,
                maximumAge: 0,
            });
        });
    }
    function changeRadius () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    }
    /**
     * Renders the results of the search and updates the map
     * @param {Object} data - Response from the server
     */
    function updateStoresResults(data) {        
        var $resultsDiv = $('.results');
        var $mapDiv = $('.map-canvas');
        let dimensions;
        var hasResults = data.stores.length > 0;

        if (!hasResults) {
            $('.store-locator-no-results').show();
        } else {
            $('.store-locator-no-results').hide();
        }

        $resultsDiv.empty()
            .data('has-results', hasResults)
            .data('radius', data.radius)
            .data('search-key', data.searchKey);

        $mapDiv.attr('data-locations', data.locations);

        if ($mapDiv.data('has-google-api')) {
            mapss(data.searchKey);
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (data.storesResultsHtml) {
            $resultsDiv.append(data.storesResultsHtml);
        }
    }
    function init () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    }
    function search () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            searchLocation($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            searchLocation($(this));
            var postalCode = $('#store-postal-code').val();
            let url = $('#customerNoUrl').val();
            let customerId;
            $.ajax({
                url: url,
                data: { selectedUrl: this.value },
                method: 'GET',
                success(dataFromAjax) {
                    //if(dataFromAjax.customerId){
                        customerId = dataFromAjax.customerId;
                        window.dataLayer.push({
                            event: "Find_Store",
                            click_text: postalCode,
                            currentPage: window.location.href,
                            nextPage: window.location.href,
                            user_id: customerId
                            }
                        );
                    //}
                },
            });
        });
    }

    storeLocator.appendToUrl=appendToUrl;
    storeLocator.maps = maps;
    storeLocator.init=init;
    storeLocator.search=search;
    storeLocator.detectLocation=detectLocation;
    storeLocator.changeRadius=changeRadius;
    storeLocator.updateStoresResults=updateStoresResults;
    module.exports = Object.assign(storeLocator);
